import { collection, onSnapshot } from 'firebase/firestore';
import { InventoryAuthority, inventoryFirestorePath } from '@qkindex/contracts';
import { Item } from '../domain/item';
import { db } from '../firebase';
import { DocumentLike, mapItemDocument } from './mappers';

interface SnapshotLike {
  docs: DocumentLike[];
}
type Listen = (
  next: (snapshot: SnapshotLike) => void,
  error: (error: Error) => void,
) => () => void;

export const createActiveItemSubscriber =
  (listen: Listen) =>
  (
    onItems: (items: Item[]) => void,
    onError: (error: Error) => void,
    onAllItems?: (items: Item[]) => void,
  ): (() => void) =>
    listen((snapshot) => {
      const allItems = snapshot.docs
        .map(mapItemDocument)
        .filter((item): item is Item => item !== null);
      onAllItems?.(allItems);
      onItems(allItems.filter(({ deleted }) => !deleted));
    }, onError);

export const subscribeToActiveItems = (
  authority: InventoryAuthority,
  onItems: (items: Item[]) => void,
  onError: (error: Error) => void,
  onAllItems?: (items: Item[]) => void,
): (() => void) =>
  createActiveItemSubscriber((next, error) =>
    onSnapshot(
      collection(db, inventoryFirestorePath(authority, 'items')),
      next,
      error,
    ),
  )(onItems, onError, onAllItems);
